import { CalendarCategory, CalendarCategoryTextFunction } from "../Types/lib";
import { IWorkersListItem } from "@/entity/workers/workers.types";
import { CalendarWorkerItem } from "@/entity/Calendar/calendar.types"; // import locale

export function parsedCategoryText(
    category: CalendarCategory,
    categoryText: string | CalendarCategoryTextFunction,
): string {
    return typeof categoryText === "string" && typeof category === "object" && category
        ? category[categoryText]
        : typeof categoryText === "function"
        ? categoryText(category)
        : category;
}

export function getParsedWorkers(workers: IWorkersListItem[]): any {
    return workers.map((worker: IWorkersListItem) => {
        //return worker['fio']
        const categoryName = worker["fio"];
        const data = {
            id: worker["id"],
        };
        return { data, categoryName };
    });
}

export function getParsedCategories(
    categories: CalendarCategory[],
    categoryText: string | CalendarCategoryTextFunction,
): CalendarCategory[] {
    return categories.map((category: CalendarCategory) => {
        if (typeof category === "string") return category;

        const categoryName =
            typeof category.categoryName === "string"
                ? category.categoryName
                : parsedCategoryText(category, categoryText);
        return { ...category, categoryName };
    });
    /*if (typeof categories === 'string') return categories.split(/\s*,\s/)
  if (Array.isArray(categories)) {
    return categories.map((category: CalendarCategory) => {
      if (typeof category === 'string') return category

      const categoryName = typeof category.categoryName === 'string'
        ? category.categoryName
        : parsedCategoryText(category, categoryText)
      return { ...category, categoryName }
    })
  }*/
    //return []
}
